
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type SubscriptionStatus = 'active' | 'cancelled' | 'paused' | 'payment_update_needed';

interface SubscriptionStatusBadgeProps {
  status: SubscriptionStatus;
}

export function SubscriptionStatusBadge({ status }: SubscriptionStatusBadgeProps) {
  const statusConfig = {
    active: {
      label: 'Активна',
      className: 'bg-green-100 text-green-800 hover:bg-green-200'
    },
    paused: {
      label: 'Приостановлена',
      className: 'bg-yellow-100 text-yellow-800 hover:bg-yellow-200'
    },
    cancelled: {
      label: 'Отменена',
      className: 'bg-red-100 text-red-800 hover:bg-red-200'
    },
    payment_update_needed: {
      label: 'Обновление карты',
      className: 'bg-blue-100 text-blue-800 hover:bg-blue-200'
    }
  };

  const config = statusConfig[status] || {
    label: status,
    className: 'bg-gray-100 text-gray-800'
  };

  return (
    <Badge variant="outline" className={cn(config.className, 'font-normal')}>
      {config.label}
    </Badge>
  );
}
